//   
// AGNES - Technical Support Web
//   
// TechnicalSupportDetailController.js
//   
// Copyright (c) 2015 Toyota Central Europe - Czech s.r.o.
//   
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//   
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//   
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
// 

angular.module("Agnes")
    .controller("TechnicalSupportDetailController", [
        "$scope", "$sessionStorage", "$http", "$activity", "$notification", "$location", "Upload", "id", "$user", "FileSaver", "Blob", "$oidc",
        function ($scope, $sessionStorage, $http, $activity, $notification, $location, uploader, id, user, FileSaver, Blob, oidc) {

            $scope.id = id;
            $scope.communicationForm = {
                message: "",
                attachments: []
            };

            // Storage
            $scope.$storage = $sessionStorage.$default({
                technicalSupportDetail: {
                    isCommunicationOpen: true,
                    isDiagFormsOpen: true,
                    isTechReportsOpen: true
                }
            });

            // Detail
            $scope.load = function () {
                $activity.start();
                $http
                    .get("/api/technical-support/" + $scope.id, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.detail = response.data;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            // Attachments
            $scope.removeAttachment = function (attachment) {
                var index = $scope.communicationForm.attachments.indexOf(attachment);
                $scope.communicationForm.attachments.slice(index, 1);
            };

            $scope.downloadAttachment = function (id) {
                $activity.start();
                $http
                    .get("/api/technical-support/attachment/download/" + id, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        var byteArray = _base64ToArrayBuffer(response.data.content);
                        var data = new Blob([byteArray], { type: response.data.type });
                        FileSaver.saveAs(data, response.data.fileName);
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    })
            }

            function _base64ToArrayBuffer(base64) {
                var binary_string = window.atob(base64);
                var len = binary_string.length;
                var bytes = new Uint8Array(len);
                for (var i = 0; i < len; i++) {
                    bytes[i] = binary_string.charCodeAt(i);
                }
                return bytes.buffer;
            }

            $scope.getTypeFromContentType = function (contentType) {
                var result = "";

                if (String(contentType).startsWith("image")) {
                    result = "image";
                } else if (String(contentType).startsWith("video")) {
                    result = "video";
                } else if (String(contentType).startsWith("audio")) {
                    result = "audio";
                } else if (contentType === "application/msword" || contentType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
                    result = "word";
                } else if (contentType === "application/vnd.ms-excel" || contentType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                    result = "excel";
                } else if (contentType === "text/xml" || contentType === "application/xml") {
                    result = "code";
                } else if (contentType === "application/pdf") {
                    result = "pdf";
                } else if (String(contentType).startsWith("text")) {
                    result = "text";
                }

                return result;
            };

            $scope.downloadDiagForm = function (id) {
                _downloadForm(id, 'diag-form');
            }

            $scope.downloadTechReport = function (id) {
                _downloadForm(id, 'tech-report');
            }

            function _downloadForm(id, documentType) {
                $activity.start();
                $http
                    .get("/api/technical-support-form/" + documentType + "/download/" + id, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        var data = new Blob([response.data.content], { type: response.data.type });
                        FileSaver.saveAs(data, response.data.fileName);
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    })
            }

            $scope.getIconFromContentType = function (contentType) {
                return $scope.getTypeFromContentType(contentType) === "" ? "fa fa-file-o" : "fa fa-file-" + $scope.getTypeFromContentType(contentType) + "-o";
            };

            $scope.getPopoverFromContentType = function (contentType) {
                var result = "";

                if ($scope.getTypeFromContentType(contentType) === "image") {
                    result = "ImagePreview.html";
                } else if ($scope.getTypeFromContentType(contentType) === "audio") {
                    result = "AudioPreview.html";
                } else if ($scope.getTypeFromContentType(contentType) === "video") {
                    result = "VideoPreview.html";
                }

                return result;
            };

            // Send message
            $scope.send = function () {
                $activity.start();
                uploader.upload({
                    url: "/api/technical-support/" + $scope.id + "/communication",
                    method: "POST",
                    fields: {
                        message: $scope.communicationForm.message
                    },
                    headers: {
                        Authorization: oidc.current.token_type + " " + oidc.current.access_token
                    },
                    sendFieldsAs: "form",
                    file: $scope.communicationForm.attachments
                }).then(function (response) {
                    $scope.communicationForm.message = "";
                    $scope.communicationForm.attachments = [];
                    $scope.detail = response.data;
                }, function (response) {
                    $notification.addError(response.status, response);
                }).then(function () {
                    $activity.finish();
                }).then(function () {
                    $location.path("/technical-support/pending");
                });
            };

            $scope.user = user;

            $scope.load();
        }
    ]);